import {getEventDescription} from '@wix/wix-events-commons-statics'
import classNames from 'classnames'
import React from 'react'
import {useWidgetState} from '../../../hooks/state-provider'
import {getDescriptionMargin, isDescriptionVisible} from '../../../selectors/single-settings'
import sc from '../../classes.scss'
import s from './description.scss'
import {DescriptionProps} from './interfaces'

export const Description = ({event, onImage}: DescriptionProps) => {
  const descriptionVisible = useWidgetState(isDescriptionVisible)
  const marginBottom = useWidgetState(getDescriptionMargin)

  return descriptionVisible ? (
    <div
      className={classNames(s.root, sc.textNoMargin, sc.preWrap, {
        [s.onImage]: onImage,
      })}
      data-hook="ev-description"
      style={{marginBottom}}
    >
      {getEventDescription(event)}
    </div>
  ) : null
}
